import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { TipoAjuste, ajustes } from 'service/api'
import { toast } from 'sonner'

type Params = {
    id: string
    tipo: TipoAjuste
}

export function ReprovarService() {
    const navigate = useNavigate()
    const { id, tipo } = useParams<Params>()
    if (!id || !tipo) navigate(-1)

    const { mutate, isLoading } = ajustes.reprovacao.mutations.useUpdate()

    const handleSubmit: SubmitHandler<any> = data => {
        mutate(
            {
                ...data,
                tipo: tipo?.toUpperCase() as TipoAjuste,
                id: Number(id),
            },
            {
                onSuccess: async () => {
                    toast.success('Reprovado com sucesso')

                    await ajustes.invalidateQueries()

                    navigate(-1)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return { handleSubmit, isLoading }
}
